import { Dialog } from 'vant'

const STORAGE_KEY = 'lxz_h5_build_time'
const VERSION_URL = '/version.json'
const POLL_INTERVAL = 5 * 60 * 1000

let checking = false
let dialogShown = false

function getStoredBuildTime() {
    return localStorage.getItem(STORAGE_KEY) || ''
}

function setStoredBuildTime(buildTime) {
    if (buildTime) {
        localStorage.setItem(STORAGE_KEY, buildTime)
    }
}

function notifyUniShell(buildTime) {
    if (window.uni && window.uni.postMessage) {
        window.uni.postMessage({
            data: { action: 'h5Updated', buildTime },
        })
    }
}

function reloadWithVersion(buildTime) {
    setStoredBuildTime(buildTime)
    notifyUniShell(buildTime)
    const url = new URL(window.location.href)
    url.searchParams.set('_v', buildTime)
    window.location.replace(url.toString())
}

function showUpdateDialog(buildTime) {
    if (dialogShown) return
    dialogShown = true
    Dialog.confirm({
        title: '版本更新',
        message: '有新版本可用，点击刷新获取最新内容',
        confirmButtonText: '立即刷新',
        cancelButtonText: '稍后',
    })
        .then(() => {
            reloadWithVersion(buildTime)
        })
        .catch(() => {
            dialogShown = false
        })
}

async function fetchServerVersion() {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
        cache: 'no-store',
    })
    if (!res.ok) return null
    return res.json()
}

export async function checkAppVersion() {
    if (checking) return
    checking = true
    try {
        const serverVersion = await fetchServerVersion()
        if (!serverVersion || !serverVersion.buildTime) return

        const stored = getStoredBuildTime()
        if (!stored) {
            setStoredBuildTime(serverVersion.buildTime)
            return
        }

        if (serverVersion.buildTime !== stored) {
            showUpdateDialog(serverVersion.buildTime)
        }
    } catch (e) {
        // ignore network errors during version check
    } finally {
        checking = false
    }
}

export function installVersionCheck() {
    if (process.env.NODE_ENV !== 'production') return

    checkAppVersion()

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            checkAppVersion()
        }
    })

    setInterval(() => {
        checkAppVersion()
    }, POLL_INTERVAL)
}
